import MicroservicesDataTable from "./MicroservicesDataTable";

export default MicroservicesDataTable;